/** The second factor of this session (decisions-log W20); who is signed in is `meQuery` (lib/session). */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { MfaConfirmResponse, MfaSetupResponse, MfaVerifyResponse } from '@outsource/shared/auth/mfa';
import { api } from '../../lib/api';
import { meQuery } from '../../lib/session';

/** A new key for the QR code; asked once when the setup screen opens. */
export function useMfaSetup() {
  return useMutation({
    mutationFn: () => api.post<MfaSetupResponse>('/auth/mfa/setup'),
    meta: { silentError: true },
  });
}

/** The first code connects the app; the recovery codes come back once. */
export function useMfaConfirm() {
  return useMutation({
    mutationFn: (code: string) => api.post<MfaConfirmResponse>('/auth/mfa/confirm', { code }),
    meta: { silentError: true },
  });
}

/** The code of this sign-in; the app opens once /me says `ok`. */
export function useMfaVerify() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (code: string) => api.post<MfaVerifyResponse>('/auth/mfa/verify', { code }),
    meta: { silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: meQuery.queryKey }),
  });
}

/** After the recovery codes were shown: /me says `ok` now and the shell opens. */
export function useOpenApp() {
  const queryClient = useQueryClient();
  return () => void queryClient.invalidateQueries({ queryKey: meQuery.queryKey });
}
